/**
 * Zone.js configuration flags — must be imported BEFORE zone.js itself (see polyfills.ts).
 *
 * Monaco editor's context menu registers mouseup listeners on HTMLLIElement nodes.
 * Zone.js wraps those event callbacks, and when it passes the event arguments into
 * Monaco's internal List.setElements(), the Zone-wrapped NodeList is no longer a
 * plain Array, causing "Y.reduce is not a function".
 *
 * Unpatching mouseup and mousedown for Zone.js fixes the root cause without affecting
 * Angular's own change detection (Angular uses its own event-binding mechanism,
 * not raw DOM addEventListener for these events in templates).
 *
 * See: https://github.com/microsoft/monaco-editor/issues/2680
 */
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['mousedown', 'mouseup'];
